import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { adsListingService } from '../ads-listing.service';
import type { TUseAdsListConfig, TUseAdsListReturn } from './use-ads-list.types';

/**
 * Hook para listar anúncios do usuário
 *
 * @example
 * ```tsx
 * const { ads, total, isLoading, refetch } = useAdsList({
 *   vehicleType: 'car',
 *   params: { limit: 10, offset: 0 },
 *   enabled: true
 * });
 * ```
 */
const useAdsList = (config: TUseAdsListConfig): TUseAdsListReturn => {
	const { vehicleType, params, enabled = true } = config;

	const { data, isLoading, isPending, isPlaceholderData, isError, error, refetch, isFetching } = useQuery({
		queryKey: ['ads', 'list', vehicleType, params],
		queryFn: () => adsListingService.listAds(vehicleType, params),
		enabled,
		placeholderData: keepPreviousData
	});

	return {
		ads: data?.ads ?? [],
		total: data?.totalCount ?? 0,
		isLoading,
		isPending,
		isPlaceholderData,
		isError,
		error: error as Error | null,
		refetch: () => {
			void refetch();
		},
		isFetching
	};
};

export { useAdsList };
